import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const CIV_CENTER: [number, number] = [7.54, -5.55];
const CIV_ZOOM = 6;

const TILE_LAYERS: Record<string, { url: string; attribution: string }> = {
  satellite: {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Esri',
  },
  osm: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap',
  },
  bnetd: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap (BNETD à configurer)',
  },
};

type BasemapType = 'satellite' | 'osm' | 'bnetd';

export default function LeafletMap({ basemap }: { basemap: BasemapType }) {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstance = useRef<L.Map | null>(null);
  const layerRef = useRef<L.TileLayer | null>(null);

  useEffect(() => {
    if (!mapRef.current) return;

    const config = TILE_LAYERS[basemap] || TILE_LAYERS.osm;
    if (!mapInstance.current) {
      mapInstance.current = L.map(mapRef.current).setView(CIV_CENTER, CIV_ZOOM);
      layerRef.current = L.tileLayer(config.url, { attribution: config.attribution }).addTo(
        mapInstance.current
      );
    } else {
      if (layerRef.current) mapInstance.current.removeLayer(layerRef.current);
      layerRef.current = L.tileLayer(config.url, { attribution: config.attribution }).addTo(
        mapInstance.current!
      );
    }
  }, [basemap]);

  return (
    <div className="leaflet-map-container" ref={mapRef}>
      {basemap === 'bnetd' && (
        <div className="leaflet-map-overlay">
          Occupation du sol BNETD : source à configurer (WMS/XYZ).
        </div>
      )}
    </div>
  );
}
